
import React from 'react';
import { Skeleton } from "@/components/ui/skeleton";
import { Card } from "@/components/ui/card";

export const EmailSummarySkeleton = () => {
  return (
    <Card className="p-4 shadow-sm">
      <div className="flex justify-between items-start mb-3">
        <div>
          <Skeleton className="h-5 w-3/4 mb-2" />
          <Skeleton className="h-4 w-1/2" />
        </div>
        <Skeleton className="h-4 w-20" />
      </div>
      
      <Skeleton className="h-4 w-full mb-1" />
      <Skeleton className="h-4 w-full mb-1" />
      <Skeleton className="h-4 w-2/3 mb-3" />
      
      <Skeleton className="h-6 w-28 mb-3" />
      
      <Skeleton className="h-px w-full my-3" />
      
      <div>
        <Skeleton className="h-4 w-1/3 mb-2" />
        <Skeleton className="h-4 w-1/2 mb-1" />
        <Skeleton className="h-4 w-1/2 mb-1" />
      </div>
      
      <div className="mt-4 flex justify-between items-center">
        <Skeleton className="h-4 w-24" />
        <div className="flex space-x-2">
          <Skeleton className="h-8 w-8 rounded" />
          <Skeleton className="h-8 w-8 rounded" />
        </div>
      </div>
    </Card>
  );
};
